import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

/**
 * Confirmación antes de activar/desactivar seguimiento PJUD (mismo patrón que eliminación masiva).
 */
@Component({
  selector: 'app-batch-scraping-toggle-confirm',
  templateUrl: './batch-scraping-toggle-confirm.component.html',
  standalone: false
})
export class BatchScrapingToggleConfirmComponent implements OnInit {
  @Input() enabled: boolean;
  @Input() count = 1;
  /** IDs de requerimientos (para mostrar "el requerimiento X" cuando count === 1). */
  @Input() requirementIds: number[] = [];
  @Output() applyToggle = new EventEmitter<void>();

  loading = false;
  headerTitle: string;
  bodyMessage: string;

  ngOnInit() {
    const n = this.count;
    const targetText =
      n === 1 && this.requirementIds?.length === 1
        ? `el requerimiento ${this.requirementIds[0]}`
        : `${n} requerimiento(s)`;
    this.headerTitle = this.enabled
      ? 'Activar seguimiento PJUD'
      : 'Desactivar seguimiento PJUD';
    this.bodyMessage = this.enabled
      ? `Se activará el seguimiento automático en el portal PJUD para ${targetText}. ¿Desea continuar?`
      : `Se desactivará el seguimiento automático en el portal PJUD para ${targetText}. ¿Desea continuar?`;
  }

  onConfirm(confirmed: boolean) {
    if (!confirmed) return;
    this.loading = true;
    this.applyToggle.emit();
  }
}
